const Insta = () => (
  <a
    href="https://www.instagram.com/brotalgut/"
    className="flex items-center mt-1 md:mb-1"
    target="_blank"
    rel="noreferrer"
  >
    <svg
      className="w-8 h-8 mr-2 md:w-12 md:h-12"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.9938 11.8341C15.9328 11.8341 11.8341 15.9328 11.8341 20.9938C11.8341 26.0547 15.9328 30.1534 20.9938 30.1534C26.0547 30.1534 30.1534 26.0547 30.1534 20.9938C30.1534 15.9328 26.0422 11.8341 20.9938 11.8341ZM20.9938 28.5039C16.8575 28.5039 13.4961 25.1425 13.4961 21.0062C13.4961 16.87 16.8575 13.5086 20.9938 13.5086C25.13 13.5086 28.4914 16.87 28.4914 21.0062C28.4914 25.1425 25.13 28.5039 20.9938 28.5039ZM30.1534 1.0125H11.8216C5.84848 1.0125 1 5.86098 1 11.8341V30.1659C1 36.139 5.84849 40.9875 11.8341 41H30.1659C36.139 41 40.9875 36.1515 41 30.1659V11.8341C41 5.86098 36.1515 1.0125 30.1659 1L30.1534 1.0125ZM39.313 30.1659C39.313 35.2268 35.2018 39.3255 30.1534 39.3255H11.8216C6.7607 39.3255 2.66198 35.2143 2.66198 30.1659V11.8341C2.66198 6.7732 6.7732 2.67448 11.8216 2.67448H30.1534C35.2143 2.67448 39.313 6.78569 39.313 11.8341V30.1659ZM33.4898 10.1721C33.4898 11.0968 32.7401 11.8341 31.8279 11.8341C30.9157 11.8341 30.1659 11.0843 30.1659 10.1721C30.1659 9.25992 30.9157 8.51015 31.8279 8.51015C32.7526 8.51015 33.4898 9.25992 33.4898 10.1721Z" />
    </svg>
  </a>
);

export default Insta;
